<template>
  <div class="about-page-headline">
    <h2 class="about-page-headline__title">
      {{ title }}
    </h2>
    <span class="about-page-headline__sub-title">{{ subTitle }}</span>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.about-page-headline {
  margin: auto;
  display: flex;
  align-items: center;
  max-width: calc(1440px - (5% * 2));

  &__title {
    font-weight: bold;
    font-size: 6rem;
    line-height: 2;
    text-align: left;
    position: relative;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 2.4rem;
    }

    @media all and (max-width: $sp-iphone5-width) {
      font-size: 2rem;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      display: inline-block;
      width: 100px;
      height: 8px;
      background-color: $primary;

      @media all and (max-width: $pc-width  - 1) {
        width: 88px;
        height: 4px;
      }
    }
  }

  &__sub-title {
    padding-left: 24px;
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 2;
    text-align: center;
    letter-spacing: 0.06em;
    color: $gray-1;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 1.4rem;
    }

    @media all and (max-width: $sp-iphone5-width) {
      font-size: 1.2rem;
    }
  }
}
</style>
